import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  header: {
    position: "fixed",
  },
  content: {
    marginTop: 70,
    padding: theme.spacing.space16,
    paddingTop: 0,
    paddingBottom: 100,
  },
  languages: {
    marginTop: theme.spacing.space24,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space12,
  },
  card: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing.space12,
    background: theme.colors.background6,
    borderRadius: theme.radius.small,
  },
  bottom: {
    padding: theme.spacing.space16,
    position: "fixed",
    width: `calc(100% - ${theme.spacing.space32}px)`,
    bottom: 0,
    paddingBottom: theme.spacing.space32,
    background: theme.colors.background1,
  },
}));
